"use client"

import { Schema } from '@/shared/types/schema.type';
import { cn } from '../../lib/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import React from 'react';
import { FormProvider, useForm, SubmitHandler, FieldValues, DefaultValues, UseFormProps } from 'react-hook-form';
import { ZodSchema, ZodType } from 'zod';

interface BaseFormProvider<T extends FieldValues> {
    children: React.ReactNode;
    schema: Schema<T>;
    defaultValues?: DefaultValues<T>;
    onSubmit: SubmitHandler<T>;
    formOptions?: UseFormProps<T>;
    formClassName?: string,
}


function BaseFormProvider<T extends FieldValues>({ 
    children, 
    schema, 
    defaultValues, 
    onSubmit, 
    formOptions,
    formClassName, 
}: BaseFormProvider<T>) {

    const form = useForm<T>({
        resolver: zodResolver(schema),
        mode: "onSubmit",
        defaultValues,
        ...formOptions,
    });

    const { errors } = form.formState

    return (
        <FormProvider {...form}>
            <form 
                className={cn('w-full', formClassName)} 
                onSubmit={form.handleSubmit(onSubmit)} 
                noValidate
            >
                {children}
            </form>
        </FormProvider>
    );
}

export default BaseFormProvider;